import React, { useCallback } from 'react';
import { BannerType, ServicesContext } from '~/services';
import { convertPagination, defaultApiResponseHandler } from '~/util';

export interface GetBannersParamsType {
    is_expired?: boolean; // eslint-disable-line babel/camelcase
    page?: null | number;
    items_per_page?: null | number; // eslint-disable-line babel/camelcase
}
export const useGetBanners = () => {
    const services = React.useContext(ServicesContext);

    const getBanners = useCallback(
        async (params: GetBannersParamsType) => {
            try {
                const result = await services.api.call({
                    method: 'get',
                    url: '/api/banners',
                    params,
                    data: {},
                    headers: {
                        'Content-Type': 'application/ld+json',
                    },
                });
                return {
                    results: result.data['hydra:member'].map((x: BannerType) => ({
                        ...x,
                        start_date: x.start_date.substring(0, 10),
                        end_date: x.end_date.substring(0, 10),
                    })),
                    pagination: convertPagination(result.data),
                };
            } catch (error) {
                throw defaultApiResponseHandler(error);
            }
        },
        [services.api]
    );

    return getBanners;
};
